// General Module
// Calendar view for tasks and future appointments

import GeneralCalendarPage from "./pages/GeneralCalendarPage";

export { GeneralCalendarPage };

export const generalRoutes = [
  { path: "/general", element: <GeneralCalendarPage /> },
];
